export const T = {
  accent: '#0A84FF',
  accentDark: '#0071E3',
  accentSoft: 'rgba(10,132,255,0.12)',
  success: '#30D158',
  warning: '#FF9F0A',
  danger: '#FF3B30',
  purple: '#BF5AF2',
  pink: '#FF375F',
  teal: '#5AC8FA',
  indigo: '#5E5CE6',
  bg: '#F2F2F7',
  surface: '#FFFFFF',
  glass: 'rgba(255,255,255,0.62)',
  glassStrong: 'rgba(255,255,255,0.78)',
  glassBorder: 'rgba(255,255,255,0.7)',
  glassRing: 'rgba(0,0,0,0.06)',
  label: '#000000',
  label2: 'rgba(60,60,67,0.6)',
  label3: 'rgba(60,60,67,0.3)',
  separator: 'rgba(60,60,67,0.12)',
  fill: 'rgba(120,120,128,0.12)',
  fill2: 'rgba(120,120,128,0.16)',
  shadow: '0 1px 2px rgba(0,0,0,0.04), 0 8px 24px rgba(0,0,0,0.06)',
  shadowStrong: '0 4px 14px rgba(0,0,0,0.08), 0 20px 40px rgba(0,0,0,0.1)',
};

export const LOGO_CONFIG = {
  url: '/Barbxpro.png',
  alt: 'Barbx Logo',
};
